export default {
  default: () => import("C:/sb/workspace/sbform/src/layouts/default.vue").then(m => m.default || m),
  "default-ym": () => import("C:/sb/workspace/sbform/src/layouts/defaultYM.vue").then(m => m.default || m),
  "default-yahoo-smartphone-purchase": () => import("C:/sb/workspace/sbform/src/layouts/defaultYahooSmartphonePurchase.vue").then(m => m.default || m)
}